module.exports = __webpack_public_path__ + "img/doubleLogo1.84bf3b78.png";